import EventEmitter from './components/event-emitter';

export enum EventKey {
    disconnect,
    showQuickComponent,
    noAccess
}

export type IEvent = {
    /**
     * 退出
     */
    [EventKey.disconnect]: () => void
    /**
     * 全局显示+号背景层
     */
    [EventKey.showQuickComponent]: (bool: boolean) => void
    /**
     * 无权限
     *
     */
    [EventKey.noAccess]: () => void
}

export let eventEmitter = new EventEmitter<IEvent>();
